export function formatFullName(
  lastName?: string | null,
  firstName?: string | null,
  middleName?: string | null,
): string {
  const parts: string[] = [];

  if (lastName) {
    parts.push(lastName);
  }

  if (firstName) {
    parts.push(firstName);
  }

  if (middleName) {
    parts.push(middleName);
  }

  return parts.join(' ');
}

export function formatCompanyName(companyName: string | null): string | null {
  if (companyName === 'Приватна особа' || !String(companyName).trim().length) {
    return null;
  }

  return companyName;
}
